export default [
  {
    path: '/team-performance',
    name: 'team-performance',
    component: () => import('@/views/teamPerformance/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.teamPerformance',
      navActiveLink: 'team-performance',
      resource: 'report-team-performance',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.teamPerformance',
          active: true,
        },
      ],
    },
  },
]
